import React from 'react'
import { MdAttachMoney, MdBalance, MdGroups } from 'react-icons/md'

import { useAnalytics } from '../../hooks'

import Button from '../Button'
import Container from '../Container'
import WhatsAppButton from '../WhatsAppButton'

export interface FeaturedCardProps {
  title: string
  icon: JSX.Element
  topics: string[]
}

export const FeaturedCard = ({ title, icon, topics }: FeaturedCardProps) => {
  const { fireEvent } = useAnalytics()

  // Disparo do evento de clique externo para WhatsApp
  const fireAnalyticsEvent = () => {
    fireEvent('send_contact', { component: 'FeaturedCard', target: 'linkWhatsapp' })

    fireEvent('externalClick', {
      component: 'FeaturedCard',
      target: 'linkWhatsapp',
    })
  }

  return (
    <div className='bg-white/50 rounded-2xl flex flex-col p-4 h-full gap-4 items-center drop-shadow-2xl shadow-[1px_1px_1px_0px_rgba(255,255,255,1)_inset] text-black opacity-100'>
      <div className='bg-gradient-to-r from-gray-900 to-gray-600 p-2 rounded-full'>
        <div className='flex justify-center items-center w-16 h-16 rounded-full'>
          <div className='flex justify-center items-center bg-white/20 text-white rounded-full w-full h-full text-rainbow'>{icon}</div>
        </div>
      </div>
      <p className='font-semibold lg:font-medium text-md lg:text-xl text-center lg:text-left'>{title}</p>
      <div className='flex flex-col gap-2 w-full'>
        <div className='p-4'>
          {topics.map((topic, index) => (
            <div key={index}>
              <p className='py-0.5 text-center'>{topic}</p>
              {index !== topics.length - 1 && <hr className='border-t-[0.5px] border-black/20 my-1' />}
            </div>
          ))}
        </div>
      </div>
      <div className='w-full'>
        <WhatsAppButton onClick={() => fireAnalyticsEvent()}>
          <Button colorSchema='styled' className='w-full bg-white/80 border-l-white border-l-2 border-t-white border-t-2' size='lg'>
            Contratar
          </Button>
        </WhatsAppButton>
      </div>
    </div>
  )
}

const FeaturedServices = () => {
  const featuredCardsContent: FeaturedCardProps[] = [
    {
      title: 'Legalizações',
      icon: <MdBalance size='2.5rem' />,
      topics: ['Abertura de empresa', 'Regularizações', 'Certificados digitais'],
    },
    {
      title: 'Operações',
      icon: <MdAttachMoney size='2.5rem' />,
      topics: ['Atividades contábeis', 'Obrigações com o fisco', 'Otimização tributária'],
    },
    {
      title: 'Pessoas',
      icon: <MdGroups size='2.5rem' />,
      topics: ['Consultoria exclusiva', 'Admissão e demissão', 'Recrutamento e seleção'],
    },
  ]

  return (
    <Container className='pt-8 pb-12 lg:pt-8 lg:pb-16 flex flex-col gap-4'>
      <div className='flex flex-col text-center lg:text-left lg:w-2/3'>
        <h3>
          <span className='font-semibold text-2xl'>O que a Hubs faz</span>
          <br />
          <span className='lg:text-lg'>para ajudar sua empresa?</span>
        </h3>

        <p className='mt-8 lg:mt-4 mb-4'>Fornecemos soluções personalizadas para cada tipo de negócio.</p>
        <p className='font-light mb-4'>
          Solicite emissão de notas fiscais, acesse guias e tenha acesso aos documentos de sua empresa de forma simples e eficiente em nossa
          plataforma digital!
        </p>
      </div>
      <div className='w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10'>
        {featuredCardsContent.map((props, index) => (
          <FeaturedCard key={index} {...props} />
        ))}
      </div>
    </Container>
  )
}

export default FeaturedServices
